<template>
  <div class="swiper-four-slides-wrapper">
    <!-- 标题和副标题 -->
    <div class="swiper-header">
      <h2 class="main-title">{{ title }}</h2>
      <p class="sub-title">{{ description }}</p>
    </div>

    <!-- 轮播容器 -->
    <div class="swiper-container-wrapper">
      <swiper
        :options="swiperOptions"
        ref="mySwiper"
      >
        <swiper-slide v-for="(image, index) in images" :key="index">
          <div class="slide-content">
            <img :src="image.url" :alt="image.alt" class="slide-image">
          </div>
        </swiper-slide>
      </swiper>
    </div>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/swiper-bundle.css'

export default {
  name: 'SwiperFourSlides',
  components: {
    Swiper,
    SwiperSlide
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      default: ''
    },
    images: {
      type: Array,
      required: true,
      default: () => []
    },
    autoplayDelay: {
      type: Number,
      default: 3000
    }
  },
  computed: {
    swiperOptions() {
      return {
        // 循环模式
        loop: true,
        // 自动播放（autoplay 参数会自动启用自动播放功能）
        autoplay: {
          delay: this.autoplayDelay,
          disableOnInteraction: false, // 用户操作后继续自动播放
          pauseOnMouseEnter: true // 鼠标悬停时暂停
        },
        // 一次显示4张
        slidesPerView: 4,
        // 每次滚动1张
        slidesPerGroup: 1,
        // 图片间距
        spaceBetween: 20,
        // 切换速度
        speed: 500,
        // 抓手光标
        grabCursor: true,
        // 启用触摸滑动
        touchRatio: 1,
        // 观察器，自动更新
        observer: true,
        observeParents: true,
        // 响应式断点
        breakpoints: {
          // 当窗口宽度 >= 1200px
          1200: {
            slidesPerView: 4,
            spaceBetween: 20
          },
          // 当窗口宽度 >= 768px
          768: {
            slidesPerView: 3,
            spaceBetween: 15
          },
          // 当窗口宽度 >= 480px
          480: {
            slidesPerView: 2,
            spaceBetween: 10
          },
          // 当窗口宽度 < 480px
          0: {
            slidesPerView: 1,
            spaceBetween: 10
          }
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
.swiper-four-slides-wrapper {
  width: 100%;
  padding: 40px 0;
  background: #fff;
}

.swiper-header {
  text-align: center;
  margin-bottom: 40px;
  padding: 0 20px;

  .main-title {
    font-size: 32px;
    font-weight: 600;
    color: rgba(5, 85, 182, 1);
    margin-bottom: 12px;
    line-height: 1.2;

    @media screen and (max-width: 768px) {
      font-size: 24px;
    }
  }

  .sub-title {
    font-size: 16px;
    color: #666;
    line-height: 1.6;
    margin: 0;

    @media screen and (max-width: 768px) {
      font-size: 14px;
    }
  }
}

.swiper-container-wrapper {
  width: 100%;
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 20px;

  @media screen and (max-width: 768px) {
    padding: 0 10px;
  }
}

.slide-content {
  position: relative;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
  background: #f5f5f5;

  &:hover {
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.12);
    transform: translateY(-4px);
  }
}

.slide-image {
  width: 100%;
  height: 240px;
  object-fit: cover;
  display: block;
  user-select: none;

  @media screen and (max-width: 768px) {
    height: 200px;
  }

  @media screen and (max-width: 480px) {
    height: 180px;
  }
}
</style>
